import { RootState } from '../Common/store/rootReducer';
import { createSelector } from 'reselect';
import { activeCTSlugSelector } from '../List/listSelectors';

export const appConfigSelector = (state: RootState) => state.appConfig.config;

export const appViewSelector = (state: RootState) => state.appConfig.view;

export const curriculumTypesSelector = createSelector(
    appConfigSelector,
    appConfig => {
        if (!appConfig || !appConfig.curriculumTypes) {
            return [];
        }
        return appConfig.curriculumTypes.map((curriculumType, index) => ({
            ...curriculumType,
            index,
        }));
    },
);

export const activeCTIndexSelector = createSelector(
    curriculumTypesSelector,
    activeCTSlugSelector,
    (curriculumTypes, activeCTSlug) => {
        let index = 0;

        curriculumTypes.forEach((ct, idx) => {
            if (ct.slug == activeCTSlug) {
                index = idx;
            }
        });

        return index;
    },
);

export const activeCurriculumTypeSelector = createSelector(
    curriculumTypesSelector,
    activeCTSlugSelector,
    (curriculumTypes, activeCTSlug) => {
        return curriculumTypes.find(ct => ct.slug == activeCTSlug);
    },
);

export const shouldRenderAZSelector = createSelector(
    activeCurriculumTypeSelector,
    activeCurriculumType => {
        return activeCurriculumType && activeCurriculumType.isAZ;
    },
);
